import type { CaseDefinition, NodeDefinition } from "../../domain/types/index.js";
import { nodeTitle } from "../shared/labels.js";
import type { MapLayout, NodeVisualState } from "./mapLayout.js";
import { nodeIcon } from "./mapNodeIcon.js";

type Props = {
  node: NodeDefinition;
  spec: CaseDefinition | null;
  visual: NodeVisualState;
  selected: boolean;
  layout: MapLayout;
  onSelect: (node: NodeDefinition) => void;
};

export function MapNode({ node, spec, visual, selected, layout, onSelect }: Props) {
  return (
    <button
      type="button"
      className={`map-node is-${visual}${selected ? " is-selected" : ""}`}
      style={{ gridColumn: layout.gridColumnOf(node), gridRow: layout.gridRowOf(node) }}
      aria-label={node.kind === "start" ? "開始地点" : node.kind === "rest" ? "休日" : node.kind === "event" ? "はてなマス" : node.kind === "relic" ? "基盤マス" : nodeTitle(node.id, spec?.name)}
      onClick={() => onSelect(node)}
    >
      <img className="map-node-icon" src={nodeIcon(node, spec)} alt="" draggable={false} />
      {spec && (
        <span className="map-node-stats">
          <span className="map-node-stat">
            <img src="/icon-progress.png" alt="進捗" />
            {node.required ?? spec.required}
          </span>
          <span className="map-node-stat">
            <img src="/icon-deadline.png" alt="工期" />
            {node.deadline ?? spec.deadline}
          </span>
        </span>
      )}
      {visual === "current" && <span className="map-node-here">▼</span>}
      {visual === "done" && <span className="map-node-check">✓</span>}
    </button>
  );
}
